import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import {stylesFor} from './quotePdfStyles';
import type {QuoteTemplate} from '../resolver/types';

type SectionLabelProps = {
	template: QuoteTemplate;
	children: string;
};

/**
 * The heading that opens every authored section: a short accent bar and the section's title in the
 * theme's heading voice. The title is resolved by the caller, so a renamed section keeps its name.
 */
const SectionLabel = ({template, children}: SectionLabelProps): JSX.Element => {
	const styles = stylesFor(template);
	const brandColor = template.branding.accentColor;
	return (
		<View style={styles.sectionLabelRow}>
			<Text style={[styles.sectionLabelText, {color: brandColor}]}>{children}</Text>
		</View>
	);
};

export default SectionLabel;
